module.exports = __webpack_public_path__ + "img/magento-modules-customization_medium.f8d647e2.webp";